import React, { useEffect, useState, useCallback } from 'react';
import { Col, message } from 'antd';

import { getSolicitacaoDetalahada } from '../../../services';

import { CabecalhoModal } from './SecaoDetalhamento/CabecalhoModal';
import { DetalhamentoSolicitacao } from './SecaoDetalhamento';

import * as S from './styles';

export function ModalDetalhamento({
  handlerModal = () => { },
  visible = false,
  dataModal = {},
}) {
  const [consulta, setConsulta] = useState(null);
  const [loading, setLoading] = useState(false);

  const getSolicitacao = useCallback(async solicitacao => {
    setLoading(true);
    const params = {
      idSolicitacao: solicitacao?.idSolicitacao,
    };

    const response = await getSolicitacaoDetalahada(params);

    if (response?.status === 200) {
      setConsulta({
        ...response?.data,
        ...dataModal,
      });
      setLoading(false);
    }

    if (response?.error) {
      message.error(
        response?.error?.response?.detail || 'Erro ao carregar dados'
      );
      setConsulta(null);
      setLoading(false);
    }
  }, [dataModal]);

  useEffect(() => {
    getSolicitacao(dataModal);
  }, [dataModal, getSolicitacao]);

  return (
    <S.ModalContainer
      width="80vw"
      footer={null}
      maskClosable={false}
      closable={true}
      centered
      explain
      open={visible}
      onCancel={handlerModal}
      title={<CabecalhoModal data={dataModal} loading={loading} />}
    >
      <S.ModalContent>
        <Col span={24}>
          <DetalhamentoSolicitacao solicitacao={consulta} loading={loading} />
        </Col>
      </S.ModalContent>
    </S.ModalContainer>
  );
}
